export default class MediaApiMapper {
	public static toApiUploadFile(file: File): FormData {
		const formData = new FormData()
		formData.append('file', file)
		return formData
	}

	public static toApiUploadMultipleFiles(files: File[]): FormData {
		const formData = new FormData()
		files.forEach((file) => {
			formData.append('files', file)
		})
		return formData
	}
}
